import { render, staticRenderFns } from "./AuthCallback.vue?vue&type=template&id=2df2cc22"
import script from "./AuthCallback.vue?vue&type=script&lang=js"
export * from "./AuthCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports